import React from "react";
import emailIcon from "../assets/images/email-gray.svg";
import phoneIcon from "../assets/images/phone-gray.svg";
import propertyIcon from "../assets/images/property-gray.svg";

export const PersonCardContentComponent = ({
                                               email,
                                               phone,
                                               secondaryPhone,
                                               properties,
                                               additionalInfo,
                                               children
                                           }
) => {

    return (
        <div className="mt-4 text-sm text-gray-500">

            <div className="mb-2 flex items-center text-sm text-gray-500">
                <img src={emailIcon} className="h-4 w-4 mr-2" alt=""/>
                <a href={`mailto:${email}`}
                   className="text-blue-600 hover:underline">{email}</a>
            </div>

            <div className="flex items-center mb-2">
                <img src={phoneIcon} className="h-4 w-4 mr-2" alt=""/>
                <a href={`tel:${phone}`}
                   className="text-blue-600 hover:underline">{phone}</a>
            </div>

            {secondaryPhone && (
                <div className="flex items-center mb-2">
                    <img src={phoneIcon} className="h-4 w-4 mr-2" alt=""/>
                    <a href={`tel:${secondaryPhone}`}
                       className="text-blue-600 hover:underline">{secondaryPhone}</a>
                </div>
            )}

            <div className="flex items-center">
                <img src={propertyIcon} className="h-4 w-4 mr-2" alt=""/>
                <span className="text-grey">
                    {properties?.length ?? 0} {properties?.length === 1 ? 'Property' : 'Properties'}
                </span>
            </div>

            {additionalInfo}

            {children}

        </div>
    );
}